module.exports = __webpack_public_path__ + "static/img/plane-1@2x.a40eb31.png";